import { Col, Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PermissionSetType } from 'api/models';
import { VisibilityId, VisibilityMeta } from 'api/visibility';
import { VisibilityOptions } from 'components/molecules/visibility-options';
import { useUserPermissionSetType } from 'hooks/permissions';
import { useAccount } from 'hooks/use-account';
import {
  useAccountVisibilityConfig,
  useCreateAccountVisibility,
  useUpdateAccountVisibility,
} from 'hooks/visibility';
import {
  Content,
  OptionsRow,
  ProjectTabsVisibilityWrapper,
  TabVisibilityHeading,
  TitleRow,
} from '../preferences/styled';

const { Paragraph } = Typography;

export const ProjectTabsVisibility = () => {
  const { accountName, company: vendorCompany } = useAccount();
  const vendorName = accountName ?? vendorCompany?.companyName;
  const currentUserPermissionSetType = useUserPermissionSetType();
  const isAccountAdmin =
    currentUserPermissionSetType === PermissionSetType.AccountAdmin;

  const config = useAccountVisibilityConfig();
  const createAccountConfig = useCreateAccountVisibility();
  const updateAccountConfig = useUpdateAccountVisibility();

  const onChange = (payload: VisibilityMeta) => {
    if (config) {
      updateAccountConfig(payload, VisibilityId(config.visibilityId));
    } else {
      createAccountConfig(payload);
    }
  };

  return isAccountAdmin ? (
    <ProjectTabsVisibilityWrapper>
      <TitleRow>
        <Col>
          <TabVisibilityHeading>
            <FormattedMessage
              id="settings.project_tabs.title"
              values={{ vendorName }}
            />
          </TabVisibilityHeading>
          <Content>
            <Paragraph>
              <FormattedMessage id="settings.project_tabs.title_help" />
            </Paragraph>
          </Content>
        </Col>
      </TitleRow>
      <OptionsRow>
        <VisibilityOptions config={config} onOptionChange={onChange} />
      </OptionsRow>
    </ProjectTabsVisibilityWrapper>
  ) : null;
};
